export const cacheDirectory = "h5-cache://"
export const documentDirectory = "h5-doc://"
export const EncodingType = { Base64: "base64", UTF8: "utf8" }

type VirtualFile = { blobUrl: string; size: number }

const virtualFiles = new Map<string, VirtualFile>()

function isRemoteUrl(uri: string) {
  return /^https?:\/\//i.test(uri)
}

export async function readAsStringAsync() {
  return ""
}

export async function writeAsStringAsync(
  fileUri: string,
  contents: string,
  options?: { encoding?: string },
) {
  if (options?.encoding === EncodingType.Base64) {
    const binary = atob(contents)
    const bytes = new Uint8Array(binary.length)
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
    const blob = new Blob([bytes])
    const blobUrl = URL.createObjectURL(blob)
    virtualFiles.set(fileUri, { blobUrl, size: blob.size })
    return
  }
  const blob = new Blob([contents], { type: "text/plain" })
  const blobUrl = URL.createObjectURL(blob)
  virtualFiles.set(fileUri, { blobUrl, size: blob.size })
}

export async function deleteAsync(uri: string) {
  const entry = virtualFiles.get(uri)
  if (entry) {
    URL.revokeObjectURL(entry.blobUrl)
    virtualFiles.delete(uri)
  }
}

export async function getInfoAsync(uri: string) {
  const entry = virtualFiles.get(uri)
  if (entry) {
    return { exists: true, size: entry.size, uri: entry.blobUrl, isDirectory: false }
  }

  if (uri.startsWith("blob:")) {
    try {
      const res = await fetch(uri)
      const blob = await res.blob()
      return { exists: blob.size > 0, size: blob.size, uri, isDirectory: false }
    } catch {
      return { exists: false }
    }
  }

  if (isRemoteUrl(uri)) {
    return { exists: true, uri, isDirectory: false }
  }

  return { exists: false }
}

export async function downloadAsync(url: string, fileUri: string) {
  const res = await fetch(url)
  if (!res.ok) {
    throw new Error(`文件下载失败 (${res.status})`)
  }
  const blob = await res.blob()
  if (blob.size <= 0) {
    throw new Error("文件下载失败或文件为空")
  }
  const blobUrl = URL.createObjectURL(blob)
  virtualFiles.set(fileUri, { blobUrl, size: blob.size })
  return { uri: blobUrl, status: res.status }
}

export async function makeDirectoryAsync() {}

export const StorageAccessFramework = {
  requestDirectoryPermissionsAsync: async () => ({ granted: false }),
  createFileAsync: async () => "",
}

export function createDownloadResumable(
  uri: string,
  fileUri: string,
  _options?: unknown,
  callback?: (result: { totalBytesWritten: number; totalBytesExpectedToWrite: number }) => void,
) {
  return {
    downloadAsync: async () => {
      const result = await downloadAsync(uri, fileUri)
      callback?.({ totalBytesWritten: 100, totalBytesExpectedToWrite: 100 })
      return { uri: result.uri, status: result.status }
    },
    pauseAsync: async () => {},
    resumeAsync: async () => {},
  }
}

export default {
  cacheDirectory,
  documentDirectory,
  EncodingType,
  readAsStringAsync,
  writeAsStringAsync,
  deleteAsync,
  getInfoAsync,
  downloadAsync,
}
